export class SubmitError extends Error {
   public readonly code: number;
   public readonly entryId?: string;
   public readonly meta?: unknown;

   constructor(
      message: string,
      code: number,
      entryId?: string,
      meta?: unknown,
   ) {
      super(message);
      this.name = 'SubmitError';
      this.code = code;
      this.entryId = entryId;
      this.meta = meta;
   }
}
